import { Component, OnInit, ViewChild } from '@angular/core';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { filter } from 'rxjs/operators';
import { SelectItem } from 'primeng/primeng';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { MatDatepicker } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import { ExcelService } from '../scrumboard/excel.service';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { SocketService } from 'app/shared/common/helper/socket.service';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  animations: fuseAnimations
})

export class AttendanceComponent implements OnInit {

  cols: any[];
  documents: any[];
  rowData = [];
  attendanceValue: any;
  reportingList = [];
  reportingToDD = [];
  deptDD = [];
  deptOptions: SelectItem[];
  reportingToOptions: SelectItem[];
  locationDD = [];
  locationOptions: SelectItem[];
  selectReporting: string[];
  selectedDate: Date;
  id: any;
  result = [];
  userTimeSheet = [];
  selectbydate = new Date();
  totalRecords: number;
  previousDate: any;
  date: any;
  profileId = '';
  userId = this.parseService.instance.User.current().id;
  empRole = '';
  attendanceByMonth = [];
  monthlyTable = [];
  month = new FormControl(moment());
  monthDate = new FormControl(moment());
  loading: boolean = false;
  today = new Date();
  // maxDate = new Date().getDate() >= 10 ? new Date() : new Date(this.today.getFullYear(), this.today.getMonth(), 0);
  maxDate = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0); tenantId: any;
  filteredEvent: string = 'all';
  user = [];

  holidaysList = [];
  filters: filter[] = [
    { value: 'all', viewValue: 'All' },
    { value: 'late', viewValue: 'Late' },
    { value: 'inTime', viewValue: 'In-Time' },
    { value: 'absent', viewValue: 'Absentees' }

  ];
  selectedValue: string = this.filters[0].value;
  @ViewChild('dt', { static: false }) private attendanceTable: any;
  excelData = [];
  totalRecordsByMonth: number;
  totalRecordsByDay: number;
  firstTimeofday: any;
  totalWorkHours = [];
  inCompletedHours = [];
  totalHours: any;
  attendanceprofileId: any;
  imageDetails: any[];
  images: any[];
  screenShotImage: any;
  element: any[];
  leaveType: any;
  leaveReason: any;
  esslEmployeeCode: any;
  timesheet = [];
  leaves = [];
  screenShots = [];
  rowResult = [];
  graceTime: any;
  inTime: any;
  timesheetArray = [];
  screenShotsArray = [];

  constructor(
    private queryInterface: QueryInterface,
    private parseService: ParseService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private storageConfiguration: StorageConfiguration,
    private excelService: ExcelService,
    private getReportingToService: GetReportingToService,
    private _socket: SocketService
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.cols = [
      { field: 'position', header: 'S.No' },
      { field: 'name', header: 'Name' },
      { field: 'reportingTo', header: 'Reporting To' },
      { field: 'startTime', header: 'Agreed StartTime' },
      { field: 'inTime', header: ' In-Time' },
      { field: 'inCompletedHours', header: ' InCompleted Hours' },
      { field: 'screenShotCounts', header: ' ScreenShot Counts' },
      { field: 'action', header: 'Time Sheet' },

    ];
    this.monthlyTable = [
      { field: 'position', header: 'S.No' },
      { field: 'userName', header: 'Name' },
      { field: 'reporting', header: 'Reporting To' },
      { field: 'absentCount', header: 'No of Absent Days' }
    ];
  }

  ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.getHolidays(new Date());
    this.tabChange(0);
  }

  async getHolidays(date) {
    const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
    const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
    holidayQuery.equalTo('year', new Date(date).getFullYear());
    this.holidaysList = await holidayQuery.find();
  }

  getEmployees() {
    this.result = [];
    let timesheetArray = [];
    let screenshotsArray = [];
    let leavesArray = [];
    const processResults = async (results) => {
      timesheetArray = await this.getEmployeesTimesheet(results);
      screenshotsArray = await this.getEmployeesScreenshots(results);
      leavesArray = await this.getEmployeesLeaves(results);

      // Concatenate all arrays into a single array
      this.result = [...timesheetArray, ...screenshotsArray, ...leavesArray];
      const result = {};

      for (const item of this.result) {
        if (!result[item.id]) {
          result[item.id] = { id: item.id };
        }

        if (item.worktime) {
          result[item.id].worktime = item.worktime;
        }

        if (item.screenshotCount) {
          result[item.id].screenshotCount = item.screenshotCount;
        }
      }

      const newArray = Object.values(result);
      // Pass the combined array to loadValue method
      this.loadValue(results, newArray)

    };
    if (this.empRole == 'Admin') {
      this.queryInterface.executeQuery(this.parseService, 'Profile',
        [
          { condition: 'limit', value: 10000 },
          { value: 'UserTimeSheet', condition: 'include' },
          { value: 'firstName', condition: 'ascending' },
          { condition: 'equalTo', field: 'isActive', value: true },
          { condition: 'equalTo', field: 'isLongLeave', value: false },
          { condition: 'equalTo', field: 'tenantId', value: this.tenantId }
        ]).then(processResults);
    }
    else if (this.empRole == 'Leader') {
      this.queryInterface.executeQuery(this.parseService, 'Profile',
        [
          { condition: 'limit', value: 10000 },
          { value: 'UserTimeSheet', condition: 'include' },
          { value: 'firstName', condition: 'ascending' },
          { condition: 'equalTo', field: 'isActive', value: true },
          { condition: 'equalTo', field: 'isLongLeave', value: false },
          { condition: 'include', value: 'reportingTo' },
          { condition: 'equalTo', field: 'reportingTo', value: { __type: 'Pointer', className: 'Profile', objectId: this.profileId } },
        ]).then(async results => {
          this.rowData = this.result;


          // console.log('timesheet', this.rowData)
          const newArray = Object.values(  this.rowData);
      // Pass the combined array to loadValue method
          this.attendanceValue = this.loadValue(results,newArray);
        }).catch(error => {
          return [];
        });
    }
    this.loading = false;
  }

  // async loadValue(results, newArray) {
  //   this.excelData = [];
  //   for (const element of results) {
  //     for (const item of newArray) {
        
  //       if (element.id == item.id) {
  //         try {
  //           const userQueryInstance = await this.parseService.instance.Object.extend('User');
  //           const userQuery = await new this.parseService.instance.Query(userQueryInstance);
  //           userQuery.equalTo('isActive', true);
  //           userQuery.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: element.id });
  //           const userData = await userQuery.find();


  //           // Other operations related to this.result or this.excelData can go here
  //           let graceTime = this.formatStartTime(element.get('officialInfo').startTime);
  //           let actualInTime = await this.getInTime(element.id);
  //           let inTime = new Date(actualInTime);
  //           let loginStatus = inTime > graceTime ? 'late' : inTime <= graceTime ? 'inTime' : inTime == null ? 'absent' : inTime.toString() == 'Invalid Date' ? 'absent' : 'present'

  //           this.rowResult.push({
  //             // position: index + 1,
  //             name: element.get('firstName') + ' ' + element.get('lastName'),
  //             startTime: element.get('officialInfo').startTime,
  //             reportingTo: element.get('reportingTo') ? element.get('reportingTo').get('firstName') + ' ' + element.get('reportingTo').get('lastName') : '',
  //             objectId: element.id,
  //             profileId: element.id,
  //             graceStartTime: graceTime,
  //             inTime: inTime,
  //             status: inTime > graceTime ? 'late' : inTime <= graceTime ? 'inTime' : inTime == null ? 'absent' : inTime.toString() == 'Invalid Date' ? 'absent' : 'present',
  //             totalHours: loginStatus == 'absent' ? '08:00 hrs' : item.worktime,
  //             screenshotsCount: loginStatus == 'absent' ? '0' : item.screenshotCount,
  //             // leaveType: loginStatus == 'absent' ? this.leaveType : undefined,
  //             // leaveReason: loginStatus == 'absent' ? this.leaveReason : undefined,
  //             // esslEmployeeCode: this.esslEmployeeCode
  //           });
  //           // console.log('this.result', this.result)

  //         } catch (error) {
  //           console.error('Error occurred:', error);
  //         }
  //       }
  //     }
  //   }
  //   this.totalRecordsByDay = this.rowResult.length;
  //   this.rowData = this.rowResult;
  // }
  async loadValue(results, newArray) {
    this.excelData = [];
    this.rowResult = []; // Initialize an array to hold the processed data for all users
  
    for (const element of results) {
      let userData = null;
      try {
        const userQueryInstance = await this.parseService.instance.Object.extend('User');
        const userQuery = await new this.parseService.instance.Query(userQueryInstance);
        userQuery.equalTo('isActive', true);
        userQuery.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: element.id });
        const userData = await userQuery.find();

        if (userData && userData.length > 0) {
          this.timesheetArray.forEach(e => {
            if (userData[0].id === e.id) {

              console.log('e.attendance', e)
            }
          })
          this.screenShotsArray.forEach(e => {
            if (e.id === element.id) {
              console.log('e.screenshotscount', e)
            }
          })
          const date = this.selectbydate !== undefined ? this.selectbydate : new Date();
          const startend = this.startenddates(date);

          this.imageDetails = [];
          let img = '';
          this.images = [];
          let description = '';
          let queryInstance = this.parseService.instance.Object.extend('UserScreenShots');
          let screenShotsQuery = new this.parseService.instance.Query(queryInstance);
          screenShotsQuery.descending('createdAt');
          screenShotsQuery.greaterThan('createdAt', startend[0]);
          screenShotsQuery.lessThan('createdAt', startend[1]);
          screenShotsQuery.include('profileId');
          screenShotsQuery.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: element.id });
          const screenShotResults = await screenShotsQuery.find();
          if (screenShotResults.length === 1) {
            let images = [];
            screenShotResults.forEach(element => {
              this.imageDetails = element.get('imageDetails');
              this.imageDetails.forEach(innerElement => {
                img = innerElement.apiUrl;
                let recordedTime = (new Date(innerElement.recordedTime));
                description = 'Screenshot';
                images.push({
                  src: img,
                  caption: recordedTime,
                  thumb: img
                });
              });
            });
            this.screenShotImage = images;
          }

          const leaveClass = this.parseService.instance.Object.extend('Leaves');
          const leaveClassQuery = await new this.parseService.instance.Query(leaveClass);

          leaveClassQuery.include('requesterId');
          leaveClassQuery.equalTo('requesterId', { __type: 'Pointer', className: 'Profile', objectId: element.id });
          leaveClassQuery.descending('createdAt');
          leaveClassQuery.greaterThan('createdAt', startend[0]);
          leaveClassQuery.lessThan('createdAt', startend[1]);
          const leaveResults = await leaveClassQuery.find();
          if (leaveResults.length) {
            const leaves = leaveResults[0];
            this.leaveType = leaves.get('leaveType');
            this.leaveReason = leaves.get('reason')
          }
          const ProfileClass = this.parseService.instance.Object.extend('Profile');
          const ProfileClassQuery = await new this.parseService.instance.Query(ProfileClass);
          ProfileClassQuery.equalTo('objectId', element.id);
          const esslEmployeeCode = await ProfileClassQuery.find();
          if (esslEmployeeCode.length) {
            const emplyCode = esslEmployeeCode[0];
            this.esslEmployeeCode = emplyCode.get('esslEmployeeCode') ? emplyCode.get('esslEmployeeCode') : ''
          }
        }

        // Other operations related to this.result or this.excelData can go here
        let graceTime = this.formatStartTime(element.get('officialInfo').startTime);
        let actualInTime = await this.getInTime(element.id);
        let inTime = new Date(actualInTime);
        let loginStatus = inTime > graceTime ? 'late' : inTime <= graceTime ? 'inTime' : inTime == null ? 'absent' : inTime.toString() == 'Invalid Date' ? 'absent' : 'present'

        this.result.push({
          // position: index + 1,
          name: element.get('firstName') + ' ' + element.get('lastName'),
          startTime: element.get('officialInfo').startTime,
          reportingTo: element.get('reportingTo') ? element.get('reportingTo').get('firstName') + ' ' + element.get('reportingTo').get('lastName') : '',
          objectId: element.id,
          profileId: element.id,
          graceStartTime: graceTime,
          inTime: inTime,
          status: inTime > graceTime ? 'late' : inTime <= graceTime ? 'inTime' : inTime == null ? 'absent' : inTime.toString() == 'Invalid Date' ? 'absent' : 'present',
          totalHours: loginStatus == 'absent' ? '08:00 hrs' : this.firstTimeofday,
          screenshotsCount: loginStatus == 'absent' ? '0' : this.screenShotImage.length,
          leaveType: loginStatus == 'absent' ? this.leaveType : undefined,
          leaveReason: loginStatus == 'absent' ? this.leaveReason : undefined,
          esslEmployeeCode: this.esslEmployeeCode
        });
        // console.log('this.result', this.result)

      } catch (error) {
        console.error('Error fetching user data:', error);
      }
  
      let loginStatus = 'absent';
      let workTime = '0'; // Default work time for absent users
      let screenshotCount = '0'; // Default screenshot count for absent users
  
      if (userData && userData.length > 0) {
        // User is logged in; determine their attendance status and related information
        this.graceTime = this.formatStartTime(element.get('officialInfo').startTime);
        let actualInTime = await this.getInTime(element.id);
        this.inTime = new Date(actualInTime);
  
        if (this.inTime.toString() === 'Invalid Date' || this.inTime == null) {
          loginStatus = 'absent';
        } else if (this.inTime > this.graceTime) {
          loginStatus = 'late';
        } else {
          loginStatus = 'inTime';
        }
  
        // Use data from newArray if available for the logged-in user
        const userArrayData = newArray.find(item => item.id === element.id);
        if (userArrayData) {
          workTime = userArrayData.worktime || '0';
          screenshotCount = userArrayData.screenshotCount || '0';
        }
      }
  
      this.rowResult.push({
        name: element.get('firstName') + ' ' + element.get('lastName'),
        startTime: element.get('officialInfo').startTime,
        reportingTo: element.get('reportingTo') ? element.get('reportingTo').get('firstName') + ' ' + element.get('reportingTo').get('lastName') : '',
        objectId: element.id,
        profileId: element.id,
        graceStartTime: this.graceTime,
        inTime: this.inTime || null,
        status: loginStatus,
        totalHours: loginStatus === 'absent' ? '08:00 hrs' : workTime,
        screenshotsCount: loginStatus === 'absent' ? '0' : screenshotCount,
      });
    }
  
    this.totalRecordsByDay = this.rowResult.length;
    this.rowData = this.rowResult;
  }
  
  async getEmployeesTimesheet(result): Promise<any[]> {
    try {
      const date = this.selectbydate !== undefined ? this.selectbydate : new Date();
      const startend = this.startenddates(date);

      const results = await this.queryInterface.executeQuery(this.parseService, 'UserTimeSheet', [
        { condition: 'limit', value: 10000 },
        { condition: 'descending', field: 'createdAt' },
        { condition: 'greaterThan', field: 'createdAt', value: startend[0] },
        { condition: 'lessThan', field: 'createdAt', value: startend[1] }
      ]);

      const timesheet = [];
      for (const element of results) {
        for (const item of result) {
          if (item.id == element.get('profileId').id) {
            let convertTime = this.secondsToHms(element.get('totalAttendance').worktime);
            timesheet.push({ id: element.get('profileId').id, worktime: convertTime })
          }
        }
      }
      return timesheet;
    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getEmployeesLeaves(result): Promise<any[]> {
    try {
      const date = this.selectbydate !== undefined ? this.selectbydate : new Date();
      const startend = this.startenddates(date);
      const results = await this.queryInterface.executeQuery(this.parseService, 'Leaves',
        [
          { condition: 'limit', value: 10000 },
          { condition: 'descending', field: 'createdAt' },
          { condition: 'greaterThan', field: 'createdAt', value: startend[0] },
          { condition: 'lessThan', field: 'createdAt', value: startend[1] }
        ])

      const leaves = []
      for (const element of results) {
        for (const item of result) {
          if (item.id == element.get('requesterId').id) {
            let leaveType = element.get('leaveType');
            let leaveReason = element.get('reason')
            leaves.push({ id: item.id, leaveType: leaveType, leaveReason: leaveReason })
          }
        }
      }
      return leaves

    } catch (error) {
      console.error(error);
      return [];
    }
  }
  async getEmployeesScreenshots(result): Promise<any[]> {
    try {
      const date = this.selectbydate !== undefined ? this.selectbydate : new Date();
      const startend = this.startenddates(date)
      const results = await this.queryInterface.executeQuery(this.parseService, 'UserScreenShots',
        [
          { condition: 'limit', value: 10000 },
          { condition: 'descending', field: 'createdAt' },
          { condition: 'greaterThan', field: 'createdAt', value: startend[0] },
          { condition: 'lessThan', field: 'createdAt', value: startend[1] },
        ])
      const screenShots = [];

      for (const data of results) {
        for (const item of result) {
          if (item.id == data.get('profileId').id) {
            this.screenShots.push({ id: item.id, screenshotCount: data.get('imageDetails').length })
          }
        }
      }
      return this.screenShots;
    } catch (error) {
      console.error(error);
      return [];
    }

  }
  concatAllData(results) {
    const result = {};

    for (const item of results) {
      if (!result[item.id]) {
        result[item.id] = { id: item.id };
      }

      if (item.worktime) {
        result[item.id].worktime = item.worktime;
      }

      if (item.screenshotCount) {
        result[item.id].screenshotCount = item.screenshotCount;
      }
    }
  }
  async getEmployeeTimesheets() {
    const date = this.selectbydate !== undefined ? this.selectbydate : new Date();
    const startend = this.startenddates(date);
    await this.queryInterface.executeQuery(this.parseService, 'UserTimeSheet',
      [
        { condition: 'limit', value: 10000 },
        { value: 'descending', condition: 'include', field: 'createdAt' },
        { condition: 'greaterThan', field: 'createdAt', value: startend[0] },
        { condition: 'lessThan', field: 'createdAt', value: startend[1] },
      ]).then(async results => {

        for (const element of results) {
          this.firstTimeofday = this.secondsToHms(element.get('totalAttendance').worktime);
          this.timesheetArray.push({ id: element.get('user').id, attendance: this.firstTimeofday })
        }

      }).catch(error => {
        return [];
      });
  }

  async getEmployeeScreenshots() {
    const date = this.selectbydate !== undefined ? this.selectbydate : new Date();
    const startend = this.startenddates(date);
    this.imageDetails = [];
    await this.queryInterface.executeQuery(this.parseService, 'UserScreenShots',
      [
        { condition: 'limit', value: 10000 },
        { value: 'descending', condition: 'include', field: 'createdAt' },
        { condition: 'greaterThan', field: 'createdAt', value: startend[0] },
        { condition: 'lessThan', field: 'createdAt', value: startend[1] },
        // { value: 'profileId', condition: 'include' },
      ]).then(async results => {
        for (const element of results) {
          // console.log('results.id', element)
          this.imageDetails = element.get('imageDetails');
          this.screenShotsArray.push({ id: element.get('profileId').id, count: this.imageDetails.length })


        }
      }).catch(error => {
        return [];
      });


  }

  exportAsXLSX() {
    if (this.filteredEvent == 'all') {
      this.element = this.rowData;
      this.processExcelData();
    }
    else {
      this.element = this.rowData.filter(a => a.status == this.filteredEvent);
      this.processExcelData();
    }
  }

  processExcelData() {
    let count = 1
    for (const e of this.element) {
      const intime = new Date(e.inTime);
      const hours = intime.getHours();
      const minutes = intime.getMinutes();
      const formattedInTime = `${hours}:${minutes}`;
      const graceTime = new Date(e.graceStartTime)
      const graceTimehours = graceTime.getHours();
      const graceTimeminutes = graceTime.getMinutes();
      const formattedGraceTime = `${graceTimehours}:${graceTimeminutes}`;
      this.excelData.push({
        'SNo': count++,
        'Profile details/Emp Code': e.esslEmployeeCode,
        'Name': e.name,
        'Start Time': e.startTime,
        'Reporting To': e.reportingTo,
        'GraceStartTime': e.status == 'Absent' ? '-' : formattedGraceTime,
        'In Time': e.status == 'Absent' ? '-' : formattedInTime,
        'Status': e.leaveType,
        'Ref': e.leaveReason,
      });
    }
    this.excelService.exportAsExcelFile(this.excelData, 'Attendance');
  }
  formatStartTime(agStartTime) {
    if (this.previousDate == undefined) {
      this.date = new Date();
    }
    else {
      this.date = this.previousDate;
    }
    var datePipe = new DatePipe('en-US');
    let startDate = datePipe.transform(this.date, 'MM/dd/yyyy');
    return new Date(new Date(startDate + ' ' + agStartTime).getTime() + (16 * 60 * 1000));
  }

  time(d) {
    return d.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    });
  }

  getInTime(id) {
    let value = this.userTimeSheet.filter(s => s.id == id)[0];
    value = value == undefined ? '' : value;
    return value.inTime;
  }

  async getUserTimeSheetInTime() {
    this.loading = true;
    let userTime = [];
    let AttendanceDB1 = this.parseService.instance.Object.extend('UserTimeSheet');
    let attendanceDB1 = new AttendanceDB1();
    let query = new this.parseService.instance.Query(attendanceDB1);
    let today = this.selectbydate ? new Date(this.selectbydate) : new Date();
    let startend = this.startenddates(today);
    this.selectedDate = today;
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.include('user');
    query.include('user.profile');
    query.limit(10000);
    query.equalTo('tenantId', this.tenantId);
    let results = await query.find();
    results.forEach(element => {
      if (element.get('user')) {
        userTime.push({ id: element.get('user').get('profile').id, inTime: element.get('inTime') == undefined ? '' : element.get('inTime') });
      }
    });
    this.userTimeSheet = userTime;
    this.getEmployees();
  }

  takePreviousData(event) {
    this.previousDate = event.value._d;
    let userTime = [];
    let AttendanceDB1 = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(AttendanceDB1);
    let datetoparse = new Date(this.selectbydate);
    this.selectedDate = this.selectbydate;
    let startend = this.startenddates(datetoparse);
    query.descending('createdAt');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.limit(300);
    query.include('user');
    query.include('user.profile');
    query.equalTo('tenantId', this.tenantId);
    query.find().then(results => {
      results.forEach(element => {
        if (element.get('user')) {
          userTime.push({ id: element.get('user').get('profile').id, inTime: element.get('inTime') == undefined ? '' : element.get('inTime') });
        }
      });
      this.userTimeSheet = userTime;
      this.getEmployees();
    });
  }

  getAttendenceByMonth(date) {
    this.loading = true;
    this.spinner.show();
    let userQueryInstance = this.parseService.instance.Object.extend('User');
    let userQuery = new this.parseService.instance.Query(userQueryInstance);
    userQuery.equalTo('isActive', true);
    userQuery.include('profile');
    userQuery.ascending('firstName');
    userQuery.limit(100000);
    userQuery.equalTo('tenantId', this.tenantId);
    userQuery.find().then(data => {
      let user = [];
      if (this.empRole == 'Leader') {
        user = data.filter(a => a.get('profile').get('reportingTo').id == this.profileId);
      }
      else {
        user = data.filter(a => (a.get('profile').get('isActive') == true) && (a.get('profile').get('isLongLeave') == false));
      }
      this.getUserSheet(user, date);
    });
  }

  async getUserSheet(data, date) {
    let ids = [];
    data.forEach(element => {
      ids.push(element.id);
    });
    let startend = this.startenddates1(new Date(date));
    let queryInstance = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(queryInstance);
    query.containedIn('user', ids);
    query.include('user');
    query.include('user.profile');
    query.include('user.profile.reportingTo');
    query.limit(100000);
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[2]);
    query.equalTo('tenantId', this.tenantId);
    let result = await query.find();
    let leaveDetails = [];
    let days = this.getLeaveWorkingDays(new Date(date));
    ids.forEach((element, index) => {
      let sheetCount = [];
      let workDates = days.workDays;
      let leaveDates = days.leaveDay;
      let workinDatesSheets = [];
      let leaveDatesSheets = [];
      let workSheets = [];
      let leaveSheets = [];
      this.attendanceByMonth = [];
      sheetCount = result.filter(x => x.get('user').id == element);
      if (sheetCount.length > 0) {
        let reporting = sheetCount[0].get('user').get('profile').get('reportingTo');

        workDates.forEach(element => {
          workinDatesSheets = sheetCount.filter(x => new Date(x.get('createdAt')).getDate() == element);
          workinDatesSheets.forEach(element => {
            workSheets.push(element);
          });
        });
        leaveDates.forEach(element => {
          leaveDatesSheets = sheetCount.filter(x => new Date(x.get('createdAt')).getDate() == element);
          leaveDatesSheets.forEach(element => {
            leaveSheets.push(element);
          });
        });
        let isActive = sheetCount[0].get('user').get('profile').get('isActive');
        let isLongLeave = sheetCount[0].get('user').get('profile').get('isLongLeave');
        leaveDetails.push({
          position: 0,
          userName: sheetCount[0].get('user').get('firstName') + ' ' + sheetCount[0].get('user').get('lastName'),
          reporting: reporting ? reporting.get('firstName') + ' ' + reporting.get('lastName') : '',
          absentCount: workDates.length - (workSheets.length <= workDates.length ? workSheets.length : workDates.length),
          // absentCount: workDates.length - workSheets.length,
          workSheets: workSheets.length,
          leaveSheets: leaveSheets.length,
          isActive: isActive,
          isLongLeave: isLongLeave
        });

      } else {
        sheetCount = data.filter(x => x.id == element);
        let reporting = sheetCount[0].get('profile').get('reportingTo');
        leaveDetails.push({
          position: 0,
          // userName: sheetCount[0].get('firstName') + ' ' + sheetCount[0].get('lastName'),
          userName: sheetCount[0] ? sheetCount[0].get('firstName') ? sheetCount[0].get('firstName') : '' + ' '
            + sheetCount[0].get('lastName') ? sheetCount[0].get('lastName') : '' : '',
          reporting: reporting ? reporting.get('firstName') + ' ' + reporting.get('lastName') : '',
          absentCount: workDates.length,
          workSheets: 0,
          leaveSheets: 0,
          isActive: sheetCount[0].get('profile').get('isActive'),
          isLongLeave: sheetCount[0].get('profile').get('isLongLeave')
        });
      }
    });
    this.loading = false;
    this.spinner.hide();
    leaveDetails = leaveDetails.sort((a, b) => (b.absentCount) - (a.absentCount));
    leaveDetails = leaveDetails.filter(x => x.isActive == true && x.isLongLeave == false);
    leaveDetails.forEach((element, index) => {
      element.position = index + 1
    });
    this.attendanceByMonth = leaveDetails;
    this.totalRecordsByMonth = this.attendanceByMonth.length;
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = this.bindDropDown(res);
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.label, value: a.label });
    });
    return dropDownItem;
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  viewTimesheet(id) {
    this.router.navigate(['timesheet-view', { id: id, event: 'attendance' }]);
    if (this.profileId != id) {
      this._socket.sendTimesheetNotification(id, 'Timesheet');
    }
  }

  filterChange(event) {
    this.filteredEvent = event
    this.rowData = this.result;
    if (event == 'all') {
      this.getUserTimeSheetInTime();
    } else {
      this.rowData = this.rowData.filter(a => a.status == event);
    }
    this.attendanceTable.reset();
  }

  startenddates1(day) {
    let getTot = this.daysInMonth(day.getMonth(), day.getFullYear(), day.getDate());
    let as = Math.round(getTot / 2);
    day.setDate(as);
    let startdate = this.daybefore1(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let middate = this.daymid(day);
    middate.setHours(0, 0, 0, 0);

    let enddate = this.dayafter1(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, middate, enddate];
  }

  daymid(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), d.getDate());
  }

  dayafter1(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth() + 1, 1);
  }

  daybefore1(d) {
    let day = new Date(d);
    return new Date(day.getFullYear(), day.getMonth(), 0);
  }

  getLeaveWorkingDays(date) {
    const d = new Date(date);
    let holidayList = this.holidaysList[0] == undefined ? {} : this.holidaysList[0].get('dateList') == undefined ? {} : this.holidaysList[0].get('dateList');
    let holidays = holidayList[d.getMonth()];

    const leaveDays = [];
    const workingDays = [];
    const getTot = this.daysInMonth(d.getMonth(), d.getFullYear(), d.getDate());
    const sat = [];
    const sun = [];

    for (let i = 1; i <= getTot; i++) {
      const newDate = new Date(d.getFullYear(), d.getMonth(), i);
      if (newDate.getDay() == 0) {
        sun.push(i);
      }
      if (newDate.getDay() == 6) {
        sat.push(i);
      }
      if (newDate.getDay() != 6 && newDate.getDay() != 0) {
        workingDays.push(i);
      }
    }
    sun.forEach(s => {
      leaveDays.push(s);
    });
    sat.forEach((sa, index) => {
      if (index % 2 == 0) {
        leaveDays.push(sa);
      } else {
        workingDays.push(sa);
      }
    });

    if (holidays != undefined) {
      holidays.forEach(element => {
        let index = workingDays.findIndex(x => x == element);
        if (index != -1) {
          workingDays.splice(index, 1);
          leaveDays.push(element);
        }
      });
    }
    return { workDays: workingDays.sort(function (a, b) { return a - b; }), leaveDay: leaveDays.sort(function (a, b) { return a - b; }) };
  }

  daysInMonth(month, year, date) {
    return new Date(year, month, date).getDate();
  }

  tabChange(event) {
    if (event == 0) {
      var d = new Date();
      let yesterday = new Date(d.setDate(d.getDate() - 1));
      this.getAttendenceByMonth(new Date(yesterday));
      this.getReportingTo();
    } else if (event == 1) {
      this.getUserTimeSheetInTime();
      this.getReportingTo();
    }
  }

  chosenYearHandler(normalizedYear: Moment): void {
    const ctrlValue = this.month != undefined ? this.month.value : '';
    if (ctrlValue != '') {
      ctrlValue.year(normalizedYear.year());
      this.month.setValue(ctrlValue);
    }
  }

  async chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    let date;
    const ctrlValue = this.month.value;
    ctrlValue.month(normalizedMonth.month());
    this.monthDate.setValue(ctrlValue);
    datepicker.close();
    date = this.monthDate.value._d;
    let yesterday = new Date();
    if ((date.getMonth() == new Date().getMonth()) && (date.getFullYear() == new Date().getFullYear())) {
      date = new Date();
      yesterday = new Date(date.setDate(date.getDate() - 1));
    }
    else {
      date = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      yesterday = date;
    }
    await this.getHolidays(new Date(yesterday));
    this.getAttendenceByMonth(new Date(yesterday));
  }

  onFilterMonth(event, dt): any {
    this.totalRecordsByMonth = event.filteredValue.length;
  }

  onFilterDay(event, dt): any {
    this.totalRecordsByDay = event.filteredValue.length;
  }

  secondsToHms(d) {
    const eightHoursInSeconds = 8 * 3600; // 8 hours in seconds
    const resultSeconds = d - eightHoursInSeconds;
    if (resultSeconds < 0) {
      const positiveResultSeconds = Math.abs(resultSeconds);

      // Convert positive result back to hours, minutes, and seconds
      const h = Math.floor(positiveResultSeconds / 3600);
      const m = Math.floor((positiveResultSeconds % 3600) / 60);
      const s = Math.floor(positiveResultSeconds % 60);

      const hDisplay = (h <= 9 ? '0' : '') + h;
      const mDisplay = (m <= 9 ? '0' : '') + m;
      const sDisplay = (s <= 9 ? '0' : '') + s;
      return `${hDisplay}:${mDisplay} hrs`;
    } else {
      // Convert result back to hours, minutes, and seconds
      d = Number(d);
      let h = Math.floor(d / 3600);
      let m = Math.floor((d % 3600) / 60);
      let s = Math.floor((d % 3600) % 60);

      let hDisplay = (h <= 9 ? '0' : '') + h;
      let mDisplay = (m <= 9 ? '0' : '') + m;
      let sDisplay = (s <= 9 ? '0' : '') + s;

      return 0 + ':' + 0 + 'hrs';
      // const h = Math.floor(resultSeconds / 3600);
      // const m = Math.floor((resultSeconds % 3600) / 60);
      // const s = Math.floor(resultSeconds % 60);

      // const hDisplay = (h <= 9 ? '0' : '') + h;
      // const mDisplay = (m <= 9 ? '0' : '') + m;
      // const sDisplay = (s <= 9 ? '0' : '') + s;

      // return `${hDisplay}:${mDisplay}:${sDisplay}`;
    }
    // d = Number(d);
    // let h = Math.floor(d / 3600);
    // let m = Math.floor((d % 3600) / 60);
    // let s = Math.floor((d % 3600) % 60);

    // let hDisplay = (h <= 9 ? '0' : '') + h;
    // let mDisplay = (m <= 9 ? '0' : '') + m;
    // let sDisplay = (s <= 9 ? '0' : '') + s;
    // return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }
}

export interface filter {
  value: string;
  viewValue: string;
}

